export default __webpack_public_path__ + "static/media/Ies_Tci.df056e91.png";